export interface IImages {
    src: string;
    alt: string;
}

export const wrapImageIndex = (index: number, imagesCount: number): number =>
    imagesCount === 0
        ? 0
        : ((index % imagesCount) + imagesCount) % imagesCount;

export const preloadImagesAround = (images: Array<IImages>, index: number): void => {
    if (typeof Image === "undefined") {
        return;
    }

    [-1, 1].forEach((offset) => {
        const neighbour = images[wrapImageIndex(index + offset, images.length)];

        if (neighbour !== undefined) {
            const preloader = new Image();
            preloader.src = neighbour.src;
        }
    });
};
